import Flickity from 'flickity'

export default class FlickitySlider {
	constructor(slider, options = null) {
		this.slider = slider
		this.slides = this.slider.querySelectorAll('.slideshow-cell')
		this.flickitySlider = null
		// this.sliderWidth = this.slider.getBoundingClientRect().width
		// this.customCursor = document.querySelector('.cursor-icon')
		this.counter = this.slider.querySelector('.counter')
		this.flickityOptions = JSON.parse(options) || {
			cellSelector: '.slideshow-cell',
			// prevNextButtons: this.slides.length > 1,
			prevNextButtons: false,
			pageDots: false,
			draggable: true,
			selectedAttraction: 0.02,
			friction: 0.2,
			autoPlay: 3000,
			pauseAutoPlayOnHover: true,
			arrowShape: {
				x0: 10,
				x1: 60,
				y1: 50,
				x2: 65,
				y2: 45,
				x3: 20
			},
			wrapAround: false,
			on: {
				change: this.changeSlide.bind(this)
			}
		}

		this.init()
		this.events()

		setTimeout(() => {
			window.dispatchEvent(new Event('resize'))
		}, 500)
	}

	changeSlide(index) {
		document.querySelector('.slider .counter .current').textContent = index + 1
	}

	init() {
		if (this.slider) {
			this.flickitySlider = new Flickity(this.slider, this.flickityOptions)
			window.FlickitySliders.push(this.flickitySlider)
		}
	}
	
	destroy() {
		this.flickitySlider.destroy()
		window.FlickitySliders.splice(window.FlickitySliders.indexOf(this.flickitySlider), 1)
	}

	setCursorPosition(x, y) {
		// this.customCursor.style.left = `${x}px`
		// this.customCursor.style.top = `${y}px`
	}

	events() {
		if (this.flickitySlider && this.flickitySlider.element.classList.contains('js-studies-slider')) {
			// this.xMousePosition = 0
			// this.yMousePosition = 0

			// this.slider.addEventListener('mousemove', (ev) => {
				// this.xMousePosition = ev.pageX - ev.currentTarget.getBoundingClientRect().left;
				// this.yMousePosition = ev.pageY - ev.currentTarget.getBoundingClientRect().top;
				// this.xMousePosition = ev.offsetX
				// this.yMousePosition = ev.offsetY

				// const elClass = this.sliderWidth / 2 - this.xMousePosition >= 0 ? 'left' : 'right'
				// this.customCursor.classList.remove(...['left', 'right'])
				// this.customCursor.classList.add(elClass)

				// this.setCursorPosition.bind(this, ev.offsetX, ev.offsetY)()
			// });

			// this.slider.addEventListener('mouseleave', () => {
				// this.xMousePosition = -1000
				// this.yMousePosition = -1000
				// this.customCursor.classList.remove(...['left', 'right'])
				// this.customCursor.classList.add('left')
				// this.setCursorPosition.bind(this, -1000, -1000)()
			// });

			// this.flickitySlider.on('dragMove', (ev) => {
			// 	console.log(ev.offsetX, ev.offsetY)
			// 	this.setCursorPosition.bind(this, ev.offsetX, ev.offsetY)()
			// })

			// this.slider.addEventListener('click', (ev) => {
			// 	// if (ev.target.matches('a')) { return true; }
			// 	// if (window.innerWidth < 992) { return true; }
			// 	// this.xMousePosition = ev.pageX - ev.currentTarget.getBoundingClientRect().left;
			// 	// this.yMousePosition = ev.pageY - ev.currentTarget.getBoundingClientRect().top;

			// 	if (this.sliderWidth / 2 - this.xMousePosition >= 0) {
			// 		this.flickitySlider.previous()
			// 	} else {
			// 		this.flickitySlider.next()
			// 	}

			// 	return true
			// });

			// [...this.slider.closest('.fade-slider').querySelectorAll('a')].forEach((element) => {
			// 	element.addEventListener('mousemove', () => {
			// 		this.customCursor.classList.add('is-a-hover');
			// 		this.setCursorPosition.bind(this)();
			// 	});

			// 	element.addEventListener('mouseleave', () => {
			// 		this.customCursor.classList.remove('is-a-hover');
			// 		this.setCursorPosition.bind(this)();
			// 	});
			// });

			// For background images
			// this.flickitySlider.on('select', (idx) => {
			// 	[...this.slider.nextElementSibling.querySelectorAll('.image-wrapper')].forEach((imageEl, index) => {
			// 		imageEl.classList.remove('is-active')

			// 		if (index === idx) {
			// 			imageEl.classList.add('is-active')
			// 		}
			// 	});
			// });
		}

		// window.addEventListener('resize', () => {
		// 	this.sliderWidth = this.slider.getBoundingClientRect().width
		// })
	}
}
